// extracted by mini-css-extract-plugin
module.exports = {"Container":"ColorShadow_Container__3dYSS","Shadow":"ColorShadow_Shadow__1x33F"};